import styled from 'styled-components';
/* Footer.css */
export const FooterContainer = styled.div`
  .footer {
    background: linear-gradient(90deg, #0b1b29 -380.41%, #554176 100%);
    height: 60px;
  }

  .footer-mobile {
    height: 36px;
  }

  .footer-wrapper {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .footer-wrapper-mobile {
    width: 100%;
  }

  .footer-btn-arrow {
    width: 121px;
    position: absolute;
    right: -55px;
    top: -24px;
    cursor: pointer;
  }

  .footer-btn-arrow-mobile {
    right: 0;
  }
`;
